import React from 'react';

const DaletChar = ({ verticalAlign = '-7px', marginRight = 0 }) => (
  <span style={{ fontSize: '1.5em', display: 'inline-block', transform: 'rotate(-20deg)', verticalAlign, marginRight, lineHeight: 0 }}>
    {'\u{10903}'}
  </span>
);

export default DaletChar;
